import { MatrixFovType, type ViewData } from '@types';

const viewDefault: ViewData = {
  fovMax: 120,
  fovMin: 70,
  fov: 95,
  fovType: 'MFOV',
  loadSceneKeepView: 0, // 加载场景时保持初始视角
  autoRotateKeepView: 0, // 自动巡游时保持初始视角
  vLookAt: 0,
  vLookAtMax: 90,
  vLookAtMin: -90,
  hLookAt: 0,
  hLookAtMax: 180,
  hLookAtMin: -180,
  flatFovType: MatrixFovType.fullscreen, // 矩阵视角类型
  maxPixelZoom: 1, // 视角最大缩放倍数
  disableZoom: 1,
};

export default viewDefault;
